import { jsx, jsxs } from "react/jsx-runtime";
import { Table, Icon } from "@zillow/constellation-10";
import PropTypes from "prop-types";
import "react";
import { getWholeDollars } from "../../utils/zhl-calculator.esm.js";
import { getRemainingMonthlyPayment } from "./DTICalculator.utils.esm.js";
const circleSvg = /* @__PURE__ */ jsx("svg", { viewBox: "0 0 10 10", children: /* @__PURE__ */ jsx("circle", { cx: "5", cy: "5", r: "4" }) });
const DTICostBreakdownTable = ({
  debtsOut,
  monthlyIncome,
  mortgagePayment
}) => /* @__PURE__ */ jsx(Table.Root, { appearance: "bare", "aria-label": "Debt to income cost breakdown table", size: "lg", alignments: ["left", "right"], children: /* @__PURE__ */ jsxs(Table.Body, { children: [
  /* @__PURE__ */ jsxs(Table.Row, { children: [
    /* @__PURE__ */ jsxs(Table.Cell, { css: {
      paddingTop: "tighter",
      paddingBottom: "0",
      paddingInline: "0"
    }, children: [
      /* @__PURE__ */ jsx(Icon, { css: {
        color: "orange.500"
      }, children: circleSvg }),
      " Total monthly debts"
    ] }),
    /* @__PURE__ */ jsx(Table.Cell, { css: {
      paddingTop: "tighter",
      paddingBottom: "0",
      paddingInline: "0",
      whiteSpace: "nowrap"
    }, children: getWholeDollars(debtsOut) })
  ] }),
  /* @__PURE__ */ jsxs(Table.Row, { children: [
    /* @__PURE__ */ jsxs(Table.Cell, { css: {
      paddingTop: "tighter",
      paddingBottom: "0",
      paddingInline: "0"
    }, children: [
      /* @__PURE__ */ jsx(Icon, { css: {
        color: "blue.900"
      }, children: circleSvg }),
      " ",
      "Mortgage payment"
    ] }),
    /* @__PURE__ */ jsx(Table.Cell, { css: {
      paddingTop: "tighter",
      paddingBottom: "0",
      paddingInline: "0",
      whiteSpace: "nowrap"
    }, children: getWholeDollars(mortgagePayment) })
  ] }),
  /* @__PURE__ */ jsxs(Table.Row, { children: [
    /* @__PURE__ */ jsxs(Table.Cell, { css: {
      paddingTop: "tighter",
      paddingBottom: "0",
      paddingInline: "0"
    }, children: [
      /* @__PURE__ */ jsx(Icon, { css: {
        color: "blue.600"
      }, children: circleSvg }),
      " ",
      "Remaining mo. income"
    ] }),
    /* @__PURE__ */ jsx(Table.Cell, { css: {
      paddingTop: "tighter",
      paddingBottom: "0",
      paddingInline: "0",
      whiteSpace: "nowrap"
    }, children: getWholeDollars(getRemainingMonthlyPayment(monthlyIncome, debtsOut, mortgagePayment)) })
  ] })
] }) });
DTICostBreakdownTable.propTypes = {
  debtsOut: PropTypes.number,
  monthlyIncome: PropTypes.number,
  mortgagePayment: PropTypes.number
};
export {
  DTICostBreakdownTable as default
};
